import styled from 'styled-components';

const CollectionTypeTableHeader = styled.div`
  align-items: center;
  display: flex;
  gap: 24px;
  justify-content: space-between;
  margin-bottom: 8px;
`;

const CollectionInfoModalList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 16px 0 0 16px;

  li {
    list-style: disc;
  }
`;

const CollectionTypeTable = styled.div``;

export { CollectionInfoModalList, CollectionTypeTable, CollectionTypeTableHeader };
